module.exports = __webpack_public_path__ + "media/images/front/products/extra/product_3-c660131551603884f6dbd38f627bbbc3.jpg";